import {
  AddMaintenanceServiceImageRequest,
  CreateMaintenanceServiceCTARequest,
  CreateMaintenanceServiceRequest,
  GetMaintenanceServiceImageRequest,
  RemoveMaintenanceServiceCTARequest,
  RemoveMaintenanceServiceImageRequest,
  UpdateMaintenanceServiceMetadataRequest,
  UpdateMaintenanceServiceOperationHoursRequest,
  UpdateMaintenanceServicePaymentMethodsRequest,
  UpdateMaintenanceServiceStoreIdsRequest,
  UpdateMaintenanceServiceTagsRequest,
} from './requests/maintenance-service-request.ts';
import { apiClient } from './client.tsx';
import {
  AddMaintenanceServiceImageResponse,
  CreateMaintenanceServiceCTAResponse,
  CreateMaintenanceServiceResponse,
  DisableMaintenanceServiceResponse,
  EnableMaintenanceServiceResponse,
  GetMaintenanceServiceImageResponse,
  GetMaintenanceServiceResponse,
  PauseMaintenanceServiceResponse,
  RemoveMaintenanceServiceCTAResponse,
  RemoveMaintenanceServiceImageResponse,
  RemoveMaintenanceServiceOperationHoursResponse,
  UpdateMaintenanceServiceMetadataResponse,
  UpdateMaintenanceServiceOperationHoursResponse,
  UpdateMaintenanceServicePaymentMethodsResponse,
  UpdateMaintenanceServiceStoreIdsResponse,
  UpdateMaintenanceServiceTagsResponse,
} from './responses/maintenance-service-response.ts';

export const createMaintenanceService = (
  request: CreateMaintenanceServiceRequest,
) =>
  apiClient
    .post<CreateMaintenanceServiceResponse>('/v2/maintenance_services', request)
    .then((res) => res.data.data);

export const updateMaintenanceServiceMetadata = (
  request: UpdateMaintenanceServiceMetadataRequest,
) =>
  apiClient
    .put<UpdateMaintenanceServiceMetadataResponse>(
      `/v2/maintenance_services/${request.serviceId}`,
      request,
    )
    .then((res) => res.data.data);

export const getMaintenanceService = (serviceId: string) =>
  apiClient
    .get<GetMaintenanceServiceResponse>(`/v2/maintenance_services/${serviceId}`)
    .then((res) => res.data.data);

export const createMaintenanceServiceCTA = (
  request: CreateMaintenanceServiceCTARequest,
) =>
  apiClient
    .post<CreateMaintenanceServiceCTAResponse>(
      `/v2/maintenance_services/${request.serviceId}/call_to_actions`,
      request,
    )
    .then((res) => res.data.data);

export const removeMaintenanceServiceCTA = (
  request: RemoveMaintenanceServiceCTARequest,
) =>
  apiClient
    .delete<RemoveMaintenanceServiceCTAResponse>(
      `/v2/maintenance_services/${request.serviceId}/call_to_actions/${request.callToActionId}`,
    )
    .then((res) => res.data.data);

export const disableMaintenanceService = (serviceId: string) =>
  apiClient
    .post<DisableMaintenanceServiceResponse>(
      `/v2/maintenance_services/${serviceId}/disable`,
    )
    .then((res) => res.data.data);

export const enableMaintenanceService = (serviceId: string) =>
  apiClient
    .post<EnableMaintenanceServiceResponse>(
      `/v2/maintenance_services/${serviceId}/enable`,
    )
    .then((res) => res.data.data);

export const addMaintenanceServiceImage = (
  request: AddMaintenanceServiceImageRequest,
) =>
  apiClient
    .post<AddMaintenanceServiceImageResponse>(
      `/v2/maintenance_services/${request.serviceId}/images`,
      request.file,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    )
    .then((res) => res.data.data);

export const removeMaintenanceServiceImage = (
  request: RemoveMaintenanceServiceImageRequest,
) =>
  apiClient
    .delete<RemoveMaintenanceServiceImageResponse>(
      `/v2/maintenance_services/${request.serviceId}/images/${request.imageId}`,
    )
    .then((res) => res.data.data);

export const getMaintenanceServiceImage = (
  request: GetMaintenanceServiceImageRequest,
) =>
  apiClient
    .get<GetMaintenanceServiceImageResponse>(
      `/v2/maintenance_services/${request.serviceId}/images/${request.imageId}`,
    )
    .then((res) => res.data.data);

export const updateMaintenanceServiceOperationHours = (
  request: UpdateMaintenanceServiceOperationHoursRequest,
) =>
  apiClient
    .put<UpdateMaintenanceServiceOperationHoursResponse>(
      `/v2/maintenance_services/${request.serviceId}/operation_hours`,
      request,
    )
    .then((res) => res.data.data);

export const removeMaintenanceServiceOperationHours = (serviceId: string) =>
  apiClient
    .delete<RemoveMaintenanceServiceOperationHoursResponse>(
      `/v2/maintenance_services/${serviceId}/operation_hours`,
    )
    .then((res) => res.data.data);

export const pauseMaintenanceService = (serviceId: string) =>
  apiClient
    .post<PauseMaintenanceServiceResponse>(
      `/v2/maintenance_services/${serviceId}/pause`,
    )
    .then((res) => res.data.data);

export const removeMaintenanceService = (serviceId: string) =>
  apiClient.delete(`/v2/maintenance_services/${serviceId}`);

export const updateMaintenanceServicePaymentMethods = (
  request: UpdateMaintenanceServicePaymentMethodsRequest,
) =>
  apiClient
    .put<UpdateMaintenanceServicePaymentMethodsResponse>(
      `/v2/maintenance_services/${request.serviceId}/payment_methods`,
      request,
    )
    .then((res) => res.data.data);

export const updateMaintenanceServiceTags = (
  request: UpdateMaintenanceServiceTagsRequest,
) =>
  apiClient
    .put<UpdateMaintenanceServiceTagsResponse>(
      `/v2/maintenance_services/${request.serviceId}/tags`,
      request,
    )
    .then((res) => res.data.data);

export const updateMaintenanceServiceStoreIds = (
  request: UpdateMaintenanceServiceStoreIdsRequest,
) =>
  apiClient
    .put<UpdateMaintenanceServiceStoreIdsResponse>(
      `/v2/maintenance_services/${request.serviceId}/stores`,
      request,
    )
    .then((res) => res.data.data);
